import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AccountFormatService } from '../account-format.service';
import { Observable } from 'rxjs';
import { ContextService } from '../context.service';
import { MsCallService } from '../ms-call.service';
import { SessionService } from '../session.service';

@Injectable({
  providedIn: 'root'
})
export class CapiService {

  formatHeaders = {};
  success_process: string = this.accountFormatService.getName().toLowerCase();
  isCallCenter: boolean;

  constructor(
    private http: HttpClient,
    private accountFormatService: AccountFormatService,
    private contextService: ContextService,
    private msCallService: MsCallService,
    private sessionService: SessionService
  ) {
    this.isCallCenter = this.sessionService.isCallCenter === 'true' ? true : false;
  }

  public tagCapi(page: string): Observable<any> {
    if (environment.mode !== 'IN' && environment.mode !== 'PF') {
      const allowedPages = ['personal-data', 'with-offer', 'without-offer', `checking-account-${this.accountFormatService.getName().toLowerCase()}-acquired`];
      this.formatHeaders = new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'channel': this.contextService.getChannelName(),
        'country': 'PE',
        'commerce': 'Banco',
        'x-flow-session-id': this.msCallService.getFlowSessionId(),
        'x-flow-transaction-id': this.msCallService.getNewId(),
        'x-session-id': this.msCallService.getSessionId(),
        'iscallcenter': String(this.isCallCenter),
        'x-flow-type': 'account'
      });
      const allowPage = allowedPages.find((pageName) => pageName === page);
      if (allowPage) {
        // se actualiza el campo PAGE ya que el back espera 'product-create'
        if (allowPage === `checking-account-${this.accountFormatService.getName().toLowerCase()}-acquired`) {
          page = 'product-create'
        }
        const url = environment.SERVICES.HOST + environment.SERVICES.CAPI;
        const request = {
          pageName: page
        };
        const headers = this.formatHeaders;
        return this.http.post(url, request, { headers });
      }
    }
    return null;
  }
}
